/**
 * @classdesc Swedish Language Pack
 * @desc This class will used to translate tokens into the Swedish language.
 * @namespace Languages.Swedish
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Swedish
 */
export const dictionary = {
	'years'   : 'År',
	'months'  : 'Månader',
	'days'    : 'Dagar',
	'hours'   : 'Timmar',
	'minutes' : 'Minuter',
	'seconds' : 'Sekunder'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Swedish
 */
export const aliases = ['sv', 'sv-se', 'swedish'];
